import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { fetchConfig } from "./configService";

// OPTIMIZED: Start fetching config immediately but don't block rendering
fetchConfig();

// Render app immediately - config will be available when components need it
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

